import '../CsvJsonInfoPages.scss';


function OptionDescriptions() {

    const data = [
        { field: 1, description: 'Option Code' },
        { field: 2, description: 'Option Description' },
    ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data - Option Descriptions</h1>
            <p>Provides the text description for each option code used in new prices and options and the standard equipment files.<br /><br />
                <b>File Naming Convention</b><br /><br />
                The &lt;FILENAME&gt; is dependant on the product being produced as follows.
            </p>

            <b>New Vehicle Prices</b>
            <p>COPDENEW.??? CARS<br />
                LOPDENEW.??? LIGHT COMMERCIALS<br />
                BOPDENEW.??? BIKES<br />
                HOPDENEW.??? HEAVIES
            </p>

            <b>Standard Equipment</b>
            <p>COPDEEQU.??? CARS<br />
                LOPDEEQU.??? LIGHT COMMERCIALS<br /><br />

                The 3 question marks (???) on each of the above files will be replaced with the day i.e. J12 for January 12th.
            </p>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
}

export default OptionDescriptions;
